import { render } from "./SubscriptionChangeView.vue?vue&type=template&id=c05775f0"
import script from "./SubscriptionChangeView.vue?vue&type=script&lang=js"
export * from "./SubscriptionChangeView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__